import type { PhoneCallStateSnapshot } from '../api/gramjs/methods/phoneCallState';

const PENDING_PHONE_CALL_STATE_KEY = 'runai_pending_phone_call_state';

export function storePendingPhoneCallStateSnapshot(snapshot: PhoneCallStateSnapshot | undefined) {
  if (!snapshot) {
    localStorage.removeItem(PENDING_PHONE_CALL_STATE_KEY);
    return;
  }

  localStorage.setItem(PENDING_PHONE_CALL_STATE_KEY, JSON.stringify(snapshot));
}

export function loadPendingPhoneCallStateSnapshot(): PhoneCallStateSnapshot | undefined {
  const raw = localStorage.getItem(PENDING_PHONE_CALL_STATE_KEY);
  if (!raw) {
    return undefined;
  }

  try {
    return JSON.parse(raw) as PhoneCallStateSnapshot;
  } catch {
    localStorage.removeItem(PENDING_PHONE_CALL_STATE_KEY);
    return undefined;
  }
}

export function clearPendingPhoneCallStateSnapshot() {
  localStorage.removeItem(PENDING_PHONE_CALL_STATE_KEY);
}
